(() => {
  const form   = document.getElementById('frete-form-pdp');
  if (!form) return;                      // não estamos na PDP

  const wrapper = document.getElementById('frete-simulator-pdp');
  const cepInp  = document.getElementById('frete-cep-pdp');
  const result  = document.getElementById('frete-resultados-pdp');

  /** Monta o payload só com o variant atual */
  const buildPayload = () => ({
    cep   : cepInp.value.replace(/\D/g, ''),
    items : [{
      weight         : +wrapper.dataset.weight,          // kg
      width          : +wrapper.dataset.width,
      height         : +wrapper.dataset.height,
      length         : +wrapper.dataset.length,
      quantity       : 1,
      insurance_value: +wrapper.dataset.price            // R$
    }]
  });

  /** Faz a cotação usando o mesmo webhook do carrinho */
  async function calcularFrete(e){
    e.preventDefault();

    const cep = cepInp.value.replace(/\D/g,'');
    if (cep.length !== 8){
      result.textContent = 'Informe um CEP válido (8 dígitos).';
      return;
    }

    result.textContent = 'Calculando…';

    try{
      const res  = await fetch('https://n8n-01-n8n.pa0kts.easypanel.host/webhook/frete-cotacao', {
        method :'POST',
        headers: {'Content-Type':'application/json'},
        body   : JSON.stringify(buildPayload())
      });
      const data = await res.json();
      const services = Array.isArray(data) ? data : (data ? [data] : []);

      if (!services.length){
        result.textContent = 'Serviço indisponível para este CEP.';
        return;
      }

      result.innerHTML = services.map(s =>
        `<p><strong>${s.name}</strong>: R$ ${s.price} — ${s.prazo} dia(s)</p>`
      ).join('');
    }catch(err){
      console.error(err);
      result.textContent = 'Não foi possível calcular o frete.';
    }
  }

  form.addEventListener('submit', calcularFrete);

  /*  Atualiza os data-attributes quando o cliente troca de variante  */
  document.addEventListener('variant:change', ({detail})=>{
    const v = detail.variant;
    if (!v) return;
    wrapper.dataset.weight = (v.weight/1000).toFixed(3);
    wrapper.dataset.price  = (v.price /100 ).toFixed(2);
    wrapper.dataset.width  = v.metafields?.dimensions?.width  ?? wrapper.dataset.width;
    wrapper.dataset.height = v.metafields?.dimensions?.height ?? wrapper.dataset.height;
    wrapper.dataset.length = v.metafields?.dimensions?.length ?? wrapper.dataset.length;
    result.textContent = '—';              // limpa resultado anterior
  });

  console.log('Simulador de frete (PDP) pronto');
})();
